(function($) {
  'use strict';

  const tabbedContent = {
    dom: function() {
      this.$tab = $('[data-tab]');
      this.$content = $('[data-tab-content]');
    },

    actions: function() {
      const _ = this;
      this.$tab.on('click', function() {
        let id = $(this).data('tab');
        _.$tab.removeClass('selected');
        $(this).addClass('selected');
        _.$content.hide().filter('[data-tab-content="' + id + '"]').show();
      });
    },

    ready: function() {
      this.dom();
      this.actions();
    }
  };

  $(function() { tabbedContent.ready(); });

})(jQuery);
